import { render } from "./SignSale.vue?vue&type=template&id=1f0dc589&scoped=true"
import script from "./SignSale.vue?vue&type=script&lang=js"
export * from "./SignSale.vue?vue&type=script&lang=js"

import "./SignSale.vue?vue&type=style&index=0&id=1f0dc589&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0dc589"]])

export default __exports__